import {z} from '@hono/zod-openapi';

import {advertisingCredentialsSchema} from './AdvertisingCommonSchemas';

export const enqueueRemoveAdvertisementRequestSchema = z
  .object({
    tenantId: z.string().uuid(),
    vehicleId: z.string().uuid().optional(),
    platformCode: z.string().min(1),
    // Omit the branch to remove the vehicle from every feed.
    publishingBranchId: z.string().uuid().nullable().optional().openapi({
      example: '99999999-9999-4999-8999-999999999999',
    }),
    credentials: advertisingCredentialsSchema.nullable(),
  })
  .openapi('EnqueueRemoveAdvertisementRequest');

export type EnqueueRemoveAdvertisementRequest = z.infer<
  typeof enqueueRemoveAdvertisementRequestSchema
>;
